import styled from "styled-components";

const ListItemCaption = styled.div`
  margin: 4px 0 0 8px;
`;

export { ListItemCaption };
